import req from 'shared/req';
import {startLoading, stopLoading} from 'shared/actions/loading';
import {RECEIVE_INSTITUTION_EARNINGS} from 'educator/action-types/institution-earnings';

const receiveInstitutionEarnings = (earnings) => ({
  type: RECEIVE_INSTITUTION_EARNINGS,
  earnings,
});

export const LOADING_IDENTIFIER = 'institutionEarnings';

export const fetchInstitutionEarnings = () => (dispatch) => {
  dispatch(startLoading(LOADING_IDENTIFIER));

  return req({
    url: '/v1/institution-earnings',
  }).then((earnings) => {
    dispatch(stopLoading(LOADING_IDENTIFIER));
    return dispatch(receiveInstitutionEarnings(earnings));
  });
};
